// Components==============

import React from 'react';
import './VideoPopup.module.scss';
import { motion } from 'framer-motion';
import Video from 'components/Layout/Menu/components/Dog/components/Video';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { useDispatch } from 'react-redux';
import updateTreatment from 'actions/treatment/update';
import retrieveUser from 'actions/authentication/retrieve';

export default function VideoPopup({
    openVideo,
    setOpenVideo,
}: {
    setOpenVideo: React.Dispatch<React.SetStateAction<number | null>>;
    openVideo: number | null;
}) {
    const dispatch = useDispatch();

    function doneViewing() {
        console.log('ik ben klaar', openVideo);
        dispatch(
            updateTreatment(openVideo, {
                markAsFinished: true,
            })
            // @ts-ignore
        ).then(() => dispatch(retrieveUser()));
    }

    return (
        <motion.div
            styleName="wrapper "
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => {
                setOpenVideo(null);
            }}
        >
            <div styleName="top">
                <span>
                    <h3>Wat is dyslexie?</h3>
                </span>
                <FontAwesomeIcon icon={faTimes} />
            </div>
            <Video
                onEnded={doneViewing}
                videoId="1997b008a16f9069b1cfb33d998ecc21"
            />
        </motion.div>
    );
}
